import React, { useEffect } from 'react'
import { listen } from './utils'

function useScrollToBlockListener({ absolutePath, isPlugin }) {


    const scrollToBlock = eventData => {
        const { blockUid } = eventData
        const block = document.querySelector(`[data-block-uid="${blockUid}"]`)
        if (block) {
            block.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
    }

    useEffect(() => {
        const listener = listen(`${absolutePath}-scrollToBlock`, scrollToBlock, isPlugin)
        return () => {
           listener.remove()
        }
    }, [!!window?.postRobot])
}

export default useScrollToBlockListener